import {gql} from 'apollo-angular';

export const GET_SCHOOL_CLASS_BY_ID = gql`
  query GetSchoolClassById($schoolClassId: Int!) {
    getSchoolClassByID(schoolClassID: $schoolClassId) {
      id
      name
      numberStudents
      grade {
        id
        name
      }
      classNumber
      classAddition
      school {
        id
        name
      }
      createdAt
      teachers {
        id
        email
        firstname
        lastname
      }
      schoolClassYear {
        id
        startYear
        endYear
        name
      }
      classCode
    }
  }
`;
